import { credibilityRules } from "@/mocks/site";
import { getVerdictStyle } from "@/utils/verdict";

export default function VerdictGuide() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <p className="text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
              结论标签
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
              四个标签，一眼看清这条瓜处在哪一步
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            分数只衡量证据，不衡量人。同一条传闻随着新材料出现，标签也会被公开更新。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {credibilityRules.map((rule) => {
            const style = getVerdictStyle(rule.verdict);
            return (
              <article
                key={rule.verdict}
                className="flex flex-col border border-background-200 rounded-card bg-background-50 p-5 hover:border-background-300 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-control border text-xs font-medium ${style.badge}`}
                  >
                    <i className="ri-checkbox-blank-circle-fill text-[7px]"></i>
                    {rule.verdict}
                  </span>
                  <span className="font-mono-num text-xs text-foreground-400">{rule.level}</span>
                </div>
                <div className="mt-4 flex gap-[3px]">
                  {Array.from({ length: 10 }).map((_, i) => (
                    <span
                      key={i}
                      className={`h-1.5 flex-1 rounded-full ${
                        i < Math.round(rule.verdict === "实锤" ? 10 : rule.verdict === "存疑" ? 7 : rule.verdict === "待定" ? 4 : 2)
                          ? style.bar
                          : "bg-background-200"
                      }`}
                    ></span>
                  ))}
                </div>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{rule.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}